
import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
  HttpParams
} from "@angular/common/http";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";

@Injectable()
export class ApiService {
  private storage: Storage;
  constructor(private http: HttpClient) {
    this.storage = localStorage;
  }

  setContentTypeHeader(options: any = {}): any {
    this.storage = localStorage;
    const headers =
      options && options.headers ? options.headers : new Headers();
    headers
      .append("content-type", "application/json");
    options.headers = headers;
    return options;
  }

  private setHeaders() {
    this.storage = localStorage;
    const headersConfig = {
      "Content-Type": "application/json",
      Accept: "application/json"
    };
    return new HttpHeaders(headersConfig);
  }

  private formatErrors(xhr: HttpErrorResponse) {
    console.error(
      `Error occurred while trying to call api. Error Details:: ${xhr.message}`
    );
    return observableThrowError({
      message: xhr.message,
      errorDetail: xhr.error
    });
  }

  get(
    path: string,
    params: HttpParams = new HttpParams(),
    responseType?
  ): Observable<any> {
    return this.http
      .get(`${path}`, { headers: this.setHeaders() })
      .catch(this.formatErrors);
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http
      .put(`${path}`, JSON.stringify(body), { headers: this.setHeaders() })
      .catch(this.formatErrors);
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http
      .post(`${path}`, JSON.stringify(body), { headers: this.setHeaders() })
      .catch(this.formatErrors);
  }

  delete(path): Observable<any> {
    return this.http
      .delete(`${path}`, { headers: this.setHeaders() })
      .catch(this.formatErrors);
  }

  getFile(path: string): Observable<any> {
    return this.http
      .get(`${path}`, {
        responseType: 'blob',
        headers: new HttpHeaders()
      })
      .catch(this.formatErrors);
  }

  postFile(path: string, input): Observable<any> {
    return this.http
      .post(`${path}`, input)
      .catch(this.formatErrors);
  }
}
